import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import UserInfoDoughnutWidget from "components/widgets/deviceData/statusWidget/UserInfoDoughnutWidget";
import HeliumLevel from "components/widgets/deviceData/HeliumLevel/HeLevel"
import MagnetPsi from "components/widgets/deviceData/MagnetPsi/MiniLineBackgroundWidget"
//import AveragePower from "components/widgets/deviceData/AveragePower/MiniLineBackgroundWidget"

import ShieldGraph from "components/widgets/deviceData/ShieldData/PageviewsChartWidget";
import Modal from "components/dashboard/Modal"



export let setDevice = () => {};
export let device = {};




const Dashboard = ({ sidebarTheme, layoutTheme }) => {

  [device, setDevice] = useState([]);

  var initialGraphData = {
    "graphType-B" : {
      "shield" : {"data" : [], "attr" : {"dataset1": "", "dataset2": "", "title": "", "key": ""}},
      "turret" : {"data" : [], "attr" : {"dataset1": "", "dataset2": "", "title": "", "key": ""}},
      "carbon1" : {"data" : [], "attr" : {"dataset1": "", "dataset2": "", "title": "", "key": ""}},
      "carbon2" : {"data" : [], "attr" : {"dataset1": "", "dataset2": "", "title": "", "key": ""}},
      "quhhtr" : {"data" : [], "attr" : {"dataset1": "", "dataset2": "", "title": "", "key": ""}},
      "swthtr" : {"data" : [], "attr" : {"dataset1": "", "dataset2": "", "title": "", "key": ""}},
      "coldhead" : {"data" : [], "attr" : {"dataset1": "", "dataset2": "", "title": "", "key": ""}},
      "attr" : {"date" : []}
    }
  }
  var initialStatusData = {
    "statusType-A": {
      "battery": {"data" : [], "attr" : {"dataset1": "", "title": "", "key": ""}},
      "volts": {"data" : [], "attr" : {"dataset1": "", "title": "", "key": ""}},
      "eis": {"data" : [], "attr" : {"dataset1": "", "title": "", "key": ""}},
      "selftest": {"data" : [], "attr" : {"dataset1": "", "title": "", "key": ""}},
      "sh": {"data" : [], "attr" : {"dataset1": "", "title": "", "key": ""}},
      "presshtr": {"data" : [], "attr" : {"dataset1": "", "title": "", "key": ""}},
      "compressor": {"data" : [], "attr" : {"dataset1": "", "title": "", "key": ""}},
      "buttons": {"data" : [], "attr" : {"dataset1": "", "title": "", "key": ""}},
      "attr" : {"date" : []}
    }
  }


  var initialLatest = {
      "Battery_Stat": "",
      "Volts": "",
      "EIS_Stat": "",
      "SelfTest_Stat": "",
      "SH_Stat": "",
      "PressHTR_Stat": "",
      "Compressor_Stat": "",
      "Buttons": "",
  }

  const [graphData, setGraphData] = useState({"graphType-A": [], "graphType-B": []});
  const [latest, setLatest] = useState(initialLatest);
  const [graphDataB, setGraphDataB] = useState({"magpsia": {"title" : "", "data": []}, "averagepower": {"title" : "", "data": []}, "time": []});


  useEffect(() => {
    if (device) {

      if (device.deviceData){
      var dataB = device.deviceData.allData.map(o => o.data)
      setGraphDataB({
        "magpsia": {"title": "Mag PsiA", "data": _.map(dataB, "MagpsiA")}, 
        "averagepower": {"title": "Average Power", "data": _.map(dataB, "AveragePower")},
        "time": device.deviceData.allData.map(o => o.time)
      })

        var deviceData = device.deviceData.allData ? device.deviceData.allData : [];
        setLatest(device.deviceData.latest)
        deviceData.map(function(val) {

          initialGraphData["graphType-B"]["shield"]["data"].push({val1 : val.data.Shield_S1, val2 : val.data.Shield_S2, status: val.data.Shield_Stat, date: val.data.date})
          initialGraphData["graphType-B"]["turret"]["data"].push({val1 : val.data.Turret_S1, val2 : val.data.Turret_S2, status: val.data.Turret_Stat,  date: val.data.date})
          initialGraphData["graphType-B"]["carbon1"]["data"].push({val1 : val.data.CarbonR_S1, val2 : val.data.CarbonR_S2, status: val.data.CarbonR_Stat1,  date: val.data.date})
          initialGraphData["graphType-B"]["carbon2"]["data"].push({val1 : val.data.CarbonR_S3, val2 : val.data.CarbonR_S4, status: val.data.CarbonR_Stat2,  date: val.data.date})
          initialGraphData["graphType-B"]["quhhtr"]["data"].push({val1 : val.data.QuhHtr_Res1, val2 : val.data.QuhHtr_Res2, status: val.data.QuhHtr_Stat,  date: val.data.date})
          initialGraphData["graphType-B"]["swthtr"]["data"].push({val1 : val.data.SwtHtr_Res1, val2 : val.data.SwtHtr_Res2, status: val.data.SwtHtr_Stat,  date: val.data.date})
          initialGraphData["graphType-B"]["coldhead"]["data"].push({val1 : val.data.ColdHead_S1, val2 : val.data.ColdHead_S2, status: val.data.MagpsiA_Stat,  date: val.data.date})

          initialStatusData["statusType-A"]["battery"]["data"].push({val1: val.data.Battery_Stat, date: val.data.date})
          initialStatusData["statusType-A"]["volts"]["data"].push({val1: val.data.Volts, date: val.data.date})
          initialStatusData["statusType-A"]["eis"]["data"].push({val1: val.data.EIS_Stat, date: val.data.date})
          initialStatusData["statusType-A"]["selftest"]["data"].push({val1: val.data.SelfTest_Stat, date: val.data.date})
          initialStatusData["statusType-A"]["sh"]["data"].push({val1: val.data.SH_Stat, date: val.data.date})
          initialStatusData["statusType-A"]["presshtr"]["data"].push({val1: val.data.PressHTR_Stat, date: val.data.date})
          initialStatusData["statusType-A"]["compressor"]["data"].push({val1: val.data.Compressor_Stat, date: val.data.date})
          initialStatusData["statusType-A"]["buttons"]["data"].push({val1: val.data.Buttons, date: val.data.date})

          initialGraphData["graphType-B"]["attr"]["date"].push(val.time)

          return true;
        })

        initialGraphData["graphType-B"]["shield"]["attr"] = {"dataset1": "Sensör 1", "dataset2": "Sensör 2", "title": "Shield", "key" : "shield"}
        initialGraphData["graphType-B"]["turret"]["attr"] = {"dataset1": "Sensör 1", "dataset2": "Sensör 2", "title": "Turret", "key" : "turret"}
        initialGraphData["graphType-B"]["carbon1"]["attr"] = {"dataset1": "Sensör 1", "dataset2": "Sensör 2", "title": "CCR 1", "key" : "carbon1"}
        initialGraphData["graphType-B"]["carbon2"]["attr"] = {"dataset1": "Sensör 3", "dataset2": "Sensör 4", "title": "CCR 2", "key" : "carbon2"}
        initialGraphData["graphType-B"]["quhhtr"]["attr"] = {"dataset1": "Res 1", "dataset2": "Res 2", "title": "QuhHtr", "key" : "quhhtr"}
        initialGraphData["graphType-B"]["swthtr"]["attr"] = {"dataset1": "Res 1", "dataset2": "Res 2", "title": "SwtHtr", "key" : "swthtr"}
        initialGraphData["graphType-B"]["coldhead"]["attr"] = {"dataset1": "Sensör 1", "dataset2": "Sensör 2", "title": "Cold Head", "key" : "coldhead"}
        

        setGraphData(initialGraphData)

        initialStatusData["statusType-A"]["battery"]["attr"] = {"title": "Battery", "key" : "battey"}
        initialStatusData["statusType-A"]["volts"]["attr"] = {"title": "Volts", "key" : "volts"}
        initialStatusData["statusType-A"]["eis"]["attr"] = {"title": "EIS", "key" : "eis"}
        initialStatusData["statusType-A"]["selftest"]["attr"] = {"title": "Self Test", "key" : "selftest"}
        initialStatusData["statusType-A"]["sh"]["attr"] = {"title": "SH", "key" : "sh"}
        initialStatusData["statusType-A"]["presshtr"]["attr"] = {"title": "Press HTR", "key" : "presshtr"}
        initialStatusData["statusType-A"]["compressor"]["attr"] = {"title": "Compressor", "key" : "compressor"}
        initialStatusData["statusType-A"]["buttons"]["attr"] = {"title": "Buttons", "key" : "buttons"}

      }
    }

  }, [device]);

  return (
    <div>
      <div>
        <div className="row ma-0">
          <div className="row ma-0" style={{width:"50%"}}>
            <h3>{device ? device.name : ''} </h3>
            <h3>{'---'} </h3>
            <h3>{device ? (device.deviceCompany ? device.deviceCompany.name : '') : ''} </h3>
          </div>
          <div style={{width:"50%", textAlign:"right"}}>
            { device &&
              <Modal device={device}/>
            }
          </div>
        </div>
        <div className="row ma-0">
          <div className="col-12 col-xl-6 col-lg-12 col-md-12 col-sm-12 ptb-15">
            {
              <HeliumLevel data={device ? (device.deviceData ? device.deviceData.latest : undefined) : undefined}/>
            }
          
          </div>
          <div className="col-12 col-xl-6 col-lg-12 col-md-12 col-sm-12 ptb-15">
            {
              <MagnetPsi
                barBackground="#FDD8CF"
                barColor="#FA7252"
                chartData={graphDataB}
              />
            }

            {/*<AveragePower
                  headline="Average Power"
                  count={device.deviceData ? (device.deviceData.latest ? device.deviceData.latest.AveragePower : undefined) : undefined}
                  barBackground="#FDD8CF"
                  barColor="#FA7252"
                  chartData={graphData["graphType-A"]["averagepower"]}
            />
            <AnalyticsProcessWidgets sidebarTheme={sidebarTheme} data={device.deviceData ? device.deviceData.allData.reverse()[0] : undefined} />*/}
          </div>
        </div>



        <div className="row ma-0">

          <div className="col-12 col-xl-7 col-lg-12 col-md-12 col-sm-12 ptb-15">
            {
              <ShieldGraph sidebarTheme={sidebarTheme} data={graphData["graphType-B"]} />
            }
          </div>
          <div className="col-12 col-xl-5 col-lg-12 col-md-12 col-sm-12 ptb-15">
            {
              <UserInfoDoughnutWidget data={latest}/>
            }
          </div>

          
        </div>
      
        
        
      </div>
        {/*
        <ThemeSetting
          mini={themeDrawer}
          closeSettingDrawer={themeSettingDrawer}
        />

        <Button
          className="dashboard-selector"
          onClick={themeSettingDrawer}
          style={{
              backgroundColor: "white",
              color: 'rgba(0,0,0,.87)'
          }}
          >
          <h5 style={{writingMode: "horizontal-tb", writingMode: "vertical-rl", textOrientation:"upright", margin:0}}>CIHAZ</h5>
        </Button>
        */}
    </div>
  );
};
const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(
  mapStateToProps,
  null
)(Dashboard);
